import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastInfoComponent } from './components/toast-templates/toast-info/toast-info.component';
import { ToastWarningComponent } from './components/toast-templates/toast-warning/toast-warning.component';
import { ToastAcknowledgmentComponent } from './components/toast-templates/toast-acknowledgment/toast-acknowledgment.component';
import { ToastErrorComponent } from './components/toast-templates/toast-error/toast-error.component';

import { TranslateModule } from '@ngx-translate/core';
import { ToastsContainerComponent } from './components/toast-templates/toasts-container/toasts-container.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { ToastRedirectComponent } from './components/toast-templates/toast-redirect/toast-redirect.component';
@NgModule({
  declarations: [
    ToastsContainerComponent,
    ToastAcknowledgmentComponent,
    ToastErrorComponent,
    ToastInfoComponent,
    ToastWarningComponent,
    ToastRedirectComponent
  ],
  imports: [CommonModule, TranslateModule, NgbModule],
  exports: [ToastsContainerComponent],
  providers: []
})
export class ToastModule {
  // static forRoot(): ModuleWithProviders {
  //   return {
  //     ngModule: PopupModule,
  //     providers: [PopupService]
  //   };
  // }
  // constructor() {
  //   // library.addIconPacks(fas, far);
  // }
}
